exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0}#mainapp{width:100%;height:100vh}", ""]);

// exports
